import { render } from "./CandleChart.vue?vue&type=template&id=29d76658"
import script from "./CandleChart.vue?vue&type=script&lang=js"
export * from "./CandleChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__